import "../k";
import { loadAllLevelSpecs, getProgress, USE_LOCAL_TEST } from "../cloudLoader";
import { goTransition } from "../util/goTransition";
import { QUIZ_GREEN } from "../util/style";

scene("loading", () => {
  const centerX = width() / 2;
  const centerY = height() / 2;

  // Loading text
  const loadingText = add([
    text("Loading...", { size: 48, font: "rumeur" }),
    pos(centerX, centerY - 60),
    anchor("center"),
    color(BLACK),
  ]);

  // Progress bar background
  const barWidth = 400;
  const barHeight = 24;
  add([
    rect(barWidth, barHeight, { radius: 12 }),
    pos(centerX, centerY + 20),
    anchor("center"),
    color(60, 60, 60),
  ]);

  // Progress bar fill
  const progressBar = add([
    rect(0, barHeight - 8, { radius: 8 }),
    pos(centerX - barWidth / 2 + 4, centerY + 20),
    anchor("left"),
    color(QUIZ_GREEN),
  ]);

  // Status text
  const statusText = add([
    text(USE_LOCAL_TEST ? "Loading test level..." : "Fetching levels...", {
      size: 20,
      font: "rumeur",
    }),
    pos(centerX, centerY + 70),
    anchor("center"),
    color(180, 180, 180),
  ]);

  // Error state
  let hasError = false;

  // Update progress bar
  onUpdate(() => {
    if (!hasError) {
      const progress = getProgress();
      progressBar.width = Math.max(0, (barWidth - 8) * progress);
    }
  });

  // Start loading
  loadAllLevelSpecs()
    .then(() => {
      statusText.text = "Ready!";
      // Small delay so user sees "Ready!"
      wait(0.3, () => {
        goTransition("start");
      });
    })
    .catch((error) => {
      hasError = true;
      console.error("Failed to load levels:", error);
      loadingText.text = "Error";
      loadingText.color = rgb(255, 100, 100);
      statusText.text = "Failed to load. Click to retry.";

      // Click to retry
      onClick(() => {
        go("loading");
      });
    });
});
